import { haptic, hapticsAvailable, iosFallback, recentlyPressedElement } from './haptics.js';
import { sound } from './sound.js';

export { haptic, hapticsAvailable, iosFallback, recentlyPressedElement } from './haptics.js';
export { celebrateOnce, resetCelebration } from './celebrate.js';
export { sound, setSoundEnabled, isSoundEnabled } from './sound.js';

/**
 * Pair haptic + sound at one call site so we never wire one without
 * the other. Synchronous — both inner calls are fire-and-forget side
 * effects that don't need awaiting. Sound is a no-op until the user
 * opts in (per [[feedback-alive-haptic-sound-feedback]]); haptic is
 * always-on where Vibration API is supported.
 */
export function feel(kind: 'tap' | 'success' | 'celebration', el?: Element | null): void {
  haptic[kind]();
  sound[kind]();
  // On a device with no vibration API — every iPhone — the two calls above can
  // both be silent no-ops, so the interaction acknowledges itself with nothing
  // at all. Passing the pressed element gives those users a real signal (G27).
  // `el` is optional because most call sites have no event in scope; when it
  // is absent the recently-pressed element is used instead, so existing
  // handlers gained the fallback without seventy edits.
  if (!hapticsAvailable()) iosFallback(el ?? recentlyPressedElement(), kind);
}
